import { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';
import { SEVERITY_COLOR, kindIconSvg } from './replayEventMeta';

/**
 * Drops a small severity-colored marker per forensic event. Clicking a pin
 * calls onSelect(event) — same seek+pan path the list/track use.
 *
 * @param {object} mapRef  ref whose .current exposes getMap() (matches MiniReplayLayer convention)
 */
export default function ReplayEventLayer({ mapRef, events, onSelect }) {
  const markersRef = useRef([]);

  useEffect(() => {
    const map = mapRef?.current?.getMap?.();
    if (!map) return undefined;

    markersRef.current.forEach((m) => m.remove());
    markersRef.current = [];

    events.forEach((e) => {
      const el = document.createElement('div');
      const color = SEVERITY_COLOR[e.severity] || SEVERITY_COLOR.info;
      el.style.cssText = `width:20px;height:20px;border-radius:9999px;border:2px solid #fff;cursor:pointer;box-shadow:0 1px 3px rgba(0,0,0,.4);background:${color};display:flex;align-items:center;justify-content:center;`;
      el.innerHTML = kindIconSvg(e.kind); // same icon as the track + timeline badges
      el.title = e.label;
      el.addEventListener('click', (ev) => { ev.stopPropagation(); onSelect(e); });
      const marker = new maplibregl.Marker({ element: el, anchor: 'center' })
        .setLngLat([e.lng, e.lat])
        .addTo(map);
      markersRef.current.push(marker);
    });

    return () => {
      markersRef.current.forEach((m) => m.remove());
      markersRef.current = [];
    };
  }, [mapRef, events, onSelect]);

  return null;
}
